
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/[...backoffice-auth]",
      function () {
        return require("private-next-pages/auth/[...backoffice-auth].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/[...backoffice-auth]"])
      });
    }
  